<template>
    <div class="experience-section mt-3 container py-3">
        <!-- Section Header -->
        <h2 class="text-center mb-5">
            We Have Better Experience in <strong>Tax Advisor</strong> & <br>
            Financial Consulting Services
        </h2>

        <!-- Services Tiles -->
        <div class="row">
            <!-- Tile 1 -->
            <div class="col-12 col-md-4 mb-3">
                <div class="service-tile px-3 py-4 text-center">
                    <!-- <img src="@/assets/NewLogo.png" alt="New Logo" class="mb-3 w-50"> -->
                    <h3 class="mb-2">Comprehensive Solutions</h3>
                    <p>
                        We provide in-depth, reliable solutions tailored to your tax advisory
                        and financial consulting needs.
                    </p>
                </div>
            </div>

            <!-- Tile 2 -->
            <div class="col-12 col-md-4 mb-3">
                <div class="service-tile px-3 py-4 text-center">
                    <!-- <img src="@/assets/TeamLogo.png" alt="Professional Team" class="mb-3 w-50"> -->
                    <h3 class="mb-2">Professional Team</h3>
                    <p>
                        Our expert team ensures top-notch guidance to help you make informed financial decisions.
                    </p>
                </div>
            </div>

            <!-- Tile 3 -->
            <div class="col-12 col-md-4 mb-3">
                <div class="service-tile px-3 py-4 text-center">
                    <!-- <img src="@/assets/SupportLogo.png" alt="24/7 Full Support" class="mb-3 w-50"> -->
                    <h3 class="mb-2">24/7 Full Support</h3>
                    <p>
                        Get round-the-clock assistance from our dedicated support team for any queries or concerns.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ExperienceSection',
};
</script>

<style scoped>
/* Overall section styling */
.experience-section {
    background-color: #fcf9f4;
    border-radius: 12px;
    padding: 2rem;
}

/* Service tile styling */
.service-tile {
    background-color: #1b662c;
    /* Green */
    color: #fff;
    border-radius: 12px;
    transition: transform 0.3s ease, background-color 0.3s ease;
}

.service-tile:hover {
    background-color: #c69064;
    /* Hover color */
    transform: translateY(-5px);
}

.service-tile img {
    max-width: 100%;
    height: auto;
    border-radius: 50%;
}

.service-tile h3 {
    font-size: 1.25rem;
    font-weight: bold;
}

.service-tile p {
    font-size: 1rem;
    line-height: 1.5;
}
</style>
